<nav class="nav account-details-nav">
  <ng-content select="a[routerLink]"></ng-content>
</nav>
